import { render } from "./AboutView.vue?vue&type=template&id=2836e89d&scoped=true"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=2836e89d&scoped=true&lang=css"

import exportComponent from "C:\\source\\LETC\\CorpWebsite\\LETC_vr_Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2836e89d"]])

export default __exports__